
import { useToast } from "@/components/ui/use-toast";

export const useExcelExporter = () => {
  const { toast } = useToast();

  const exportToExcel = async (exportData: Record<string, string>[], filename: string, languages: string[], showProductDetails: boolean = false) => {
    try {
      const XLSX = await import('xlsx');
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Set column widths
      const colWidths = [
        { wch: 15 }, // Article Number
        { wch: 30 }, // Product Name
        { wch: 60 }, // Generated Description
      ];
      
      if (showProductDetails) {
        colWidths.push({ wch: 40 }); // Product Details
      }
      
      languages.forEach(() => {
        colWidths.push({ wch: 60 }); // Translation text
        if (showProductDetails) {
          colWidths.push({ wch: 40 }); // Translation details
        }
      });
      
      ws['!cols'] = colWidths;

      XLSX.utils.book_append_sheet(wb, ws, 'Aggregated Data');
      
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.xlsx`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast({
        title: "Success",
        description: "Aggregated file exported successfully as Excel",
      });
    } catch (error) {
      console.error('Excel export error:', error);
      toast({
        title: "Error",
        description: "Failed to export Excel file",
        variant: "destructive",
      });
    }
  };

  return { exportToExcel };
};
